var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_402_16376",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_402_16376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91532 25.0834C4.379 25.0834 3.92505 24.8792 3.55347 24.4709C3.18189 24.0626 2.99609 23.5637 2.99609 22.9744V5.02579C2.99609 4.43643 3.18189 3.93758 3.55347 3.52925C3.92505 3.12091 4.379 2.91675 4.91532 2.91675H12.5532C12.8091 2.91675 13.0551 2.97139 13.2913 3.08066C13.5274 3.18975 13.7326 3.34005 13.9068 3.53158L18.3616 8.42691C18.5359 8.61844 18.6727 8.8439 18.7719 9.10329C18.8714 9.36287 18.9211 9.63325 18.9211 9.91441V22.9744C18.9211 23.5637 18.7353 24.0626 18.3637 24.4709C17.9921 24.8792 17.5382 25.0834 17.0019 25.0834H4.91532ZM12.5511 8.86208V4.66675H4.91532C4.83357 4.66675 4.75873 4.70418 4.69078 4.77904C4.62266 4.85371 4.58859 4.93596 4.58859 5.02579V22.9744C4.58859 23.0642 4.62266 23.1465 4.69078 23.2211C4.75873 23.296 4.83357 23.3334 4.91532 23.3334H17.0019C17.0836 23.3334 17.1585 23.296 17.2264 23.2211C17.2945 23.1465 17.3286 23.0642 17.3286 22.9744V9.91675H13.5108C13.2371 9.91675 13.0088 9.81612 12.8258 9.61487C12.6427 9.41382 12.5511 9.16289 12.5511 8.86208Z",
    fill: "#9A91C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageIcon);
export default __webpack_public_path__ + "static/media/no-image-icon.d0ed20a791e1dda56fc2a2ae15ac9aa3.svg";
export { ForwardRef as ReactComponent };